import { DropdownButtonType, List, ListItem, SingleSelectDropdown } from '@tableau/widgets';
import React from 'react';
import { defaultMemoize } from 'reselect';

import { Messages } from '../../../../../gen-src/Localize';
import { FlowQuery } from '../../../../../gen-src/queries';
import {
  DropdownSelectedItem,
  dropdownStyle
} from '../../../data-catalog-shared';

type FlowQuery_flows_outputSteps = Unpacked<Unpacked<FlowQuery['flows']>['outputSteps']>

function createListItems(outputSteps: ReadonlyArray<FlowQuery_flows_outputSteps>): ListItem[] {
  return outputSteps.map(outputStep => {
    return {
      value: outputStep.id,
      content: outputStep.name || Messages.PermissionsRequired(), // should never reach perm required case
      tooltip: outputStep.name || Messages.PermissionsRequired()
    };
  });
}

export type FlowOutputStepSelectorProps = {
  readonly selectedOutputStep: string;
  readonly outputSteps: ReadonlyArray<FlowQuery_flows_outputSteps>;
  readonly updateOutputStepSelection: (outputStepId: string) => void;
};

export class FlowOutputStepSelector extends React.PureComponent<FlowOutputStepSelectorProps> {

  private memoizedListItems = defaultMemoize(createListItems);

  private getSelectedOutputStepName(): string {
    const selectedOutputStep = this.props.outputSteps.find(os => os.id === this.props.selectedOutputStep);
    return selectedOutputStep && selectedOutputStep.name ? selectedOutputStep.name : Messages.PermissionsRequired();
  }

  public override render(): JSX.Element {
    const listItems = this.memoizedListItems(this.props.outputSteps);
    const outputStepName = this.getSelectedOutputStepName();
    return (
      <SingleSelectDropdown
        label={''}
        list={
          <List
            items={listItems}
            selectedValue={this.props.selectedOutputStep}
          />
        }
        type={DropdownButtonType.Outline}
        value={this.props.selectedOutputStep}
        onChange={this.props.updateOutputStepSelection}
        style={dropdownStyle}
      >
        <DropdownSelectedItem title={outputStepName}>{outputStepName}</DropdownSelectedItem>
      </SingleSelectDropdown>
    );
  }
}
